import React from "react";
import OppositionForm from "./OppositionForm";
import OppositionList from "./OppositionList";
import { getUser } from "../auth/Auth";
import { translate } from "../base/Translation";

export default class Opposition extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            reload: false,
            canAdd: this.getCanAdd(),
        }
    }

    reload() {
        this.setState({ reload: !this.state.reload });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.test !== nextProps.test) {
            this.setState({ canAdd: this.getCanAdd() });
        }
    }

    getCanAdd() {
        let canAdd = false;

        if (getUser().role === 2 && this.props.test.status_val === "done") {
            canAdd = true;
        }

        if (getUser().role === 3 && this.props.test.status_val === "closed") {
            canAdd = true;
        }

        return canAdd;
    }

    addButton() {

        if (!this.state.canAdd) {
            return false;
        }

        return (
            <div className="row">
                <div className="col-sm-12">
                    <div className="form-group" style={{ textAlign: "right" }}>
                        <button className="btn btn-primary btn-sm">
                            <i className="fa fa-plus" />&nbsp;{translate("Pridať námietku")}
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    form() {
        if (!this.state.canAdd) {
            return false;
        }

        return <OppositionForm test={this.props.test} reload={this.reload.bind(this)} />;
    }

    render() {
        return (
            <div>
                {/*this.addButton()*/}
                <div className="row">
                    <div className="col-sm-12">
                        {this.form()}
                        <OppositionList test={this.props.test} reload={this.state.reload} />
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/opposition/Opposition.jsx